import { render, staticRenderFns } from "./o-prices.vue?vue&type=template&id=22090212&scoped=true"
import script from "./o-prices.vue?vue&type=script&lang=js"
export * from "./o-prices.vue?vue&type=script&lang=js"
import style0 from "./o-prices.vue?vue&type=style&index=0&id=22090212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22090212",
  null
  
)

export default component.exports